/* global localStorage, window, FB */
let jwtDecode = require('jwt-decode')
export default {
  user: {
    authenticated: false,
    profile: {},
    socialError: false,
    activatedError: false,
    error: false,
    error_message: '',
    loading: false,
    loadingFB: false,
    require_email: false
  },
  prem_user_data: {},
  loggedIn () {
    let token = localStorage.id_token

    if (!token) {
      delete localStorage.id_token
      delete localStorage.profile
      this.user.authenticated = false
      this.onChange(false)
      return this.user.authenticated
    }

    let decoded = jwtDecode(token)
    let now = Date.now() / 1000

    // token expired despite being present => log out
    if (decoded.exp < Number(now.toFixed(0))) {
      delete localStorage.id_token
      delete localStorage.profile
      delete localStorage.business
      delete localStorage.review
      this.user.authenticated = false
      return false
    }

    if (token !== null) {
      this.user.profile = JSON.parse(localStorage.profile)
    }

    if (!this.user.profile.activated) {
      this.user.authenticated = false
      this.user.activatedError = false
      this.user.error = true
      this.user.error_message = `This account still needs to be activated. We have sent an email to ${this.user.profile.email} for you to activate your account and complete registration.`
      this.onChange(false)
      return this.user.authenticated
    } else {
      this.user.authenticated = true
      this.user.activatedError = false
      this.user.error = false
      this.user.error_message = ''
      this.onChange(true)
      return this.user.authenticated
    }
  },
  onChange () {},
  updateProfile (profile) {
    localStorage.profile = JSON.stringify(profile)
    this.user.profile = profile
  },
  FBInit (context) {
    setTimeout(function () {
      if (!window.FB) {
        window.fbAsyncInit = function () {
          FB.init({
            appId: process.env.FACEBOOK_APP_ID,
            status: true,
            xfbml: true,
            version: 'v2.10'
          })
        }
      } else {
        window.FB.init({
          appId: process.env.FACEBOOK_APP_ID,
          status: true,
          xfbml: true,
          version: 'v2.10'
        })
      }
    }, 300)
  }
}



// WEBPACK FOOTER //
// ./src/auth.js